// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"125":"component---src-pages-404-js","279":"component---src-pages-index-jsx"}[chunkId] + "-" + {"125":"46e581b9f4dbab82e248","279":"522f7e6bcd9e83699fa1"}[chunkId] + ".js";
};